import { initializeApp, getApps } from 'firebase/app';
import { browserLocalPersistence, getAuth, setPersistence } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

function getFirebaseConfig() {
  const firebaseConfig = {
    apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
    authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
    storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
  };

  const missing = Object.entries(firebaseConfig)
    .filter(([, value]) => !value)
    .map(([key]) => key);

  if (missing.length > 0) {
    return null;
  }

  return firebaseConfig as Required<typeof firebaseConfig>;
}

const isBrowser = typeof window !== 'undefined';

const appConfig = isBrowser ? getFirebaseConfig() : null;
const app = isBrowser && appConfig ? (getApps().length === 0 ? initializeApp(appConfig) : getApps()[0]) : null;
const auth = app ? getAuth(app) : null;
const storage = app ? getStorage(app) : null;

if (isBrowser && auth) {
  void setPersistence(auth, browserLocalPersistence).catch(() => {});
}

export { app, auth, storage };
